export default __webpack_public_path__ + "static/media/wallet-icon.fc625f89.svg";